import React from "react";
import styles from "./SkeletonCard.module.css";

/**
 * SkeletonCard — placeholder animé affiché pendant le chargement des voyages.
 *
 * Reproduit fidèlement la forme de la Card réelle (même ratio image 3:2,
 * même structure contenu) pour éviter le layout shift une fois les données chargées.
 *
 * Props :
 *   type  "grille" (défaut) | "liste"
 */
export const SkeletonCard = ({ type = "grille" }) => {
  if (type === "liste") {
    return (
      <div className={styles.cardListe} aria-hidden="true">
        <div className={styles.imageListe} />
        <div className={styles.contentListe}>
          <div className={styles.title} />
          <div className={styles.titleShort} />
          <div className={styles.location} />
          <div className={styles.divider} />
          <div className={styles.footer}>
            <div className={styles.footerChip} />
            <div className={styles.footerChip} />
          </div>
          <div className={styles.priceLabel} />
          <div className={styles.priceValue} />
        </div>
      </div>
    );
  }

  return (
    <div className={styles.card} aria-hidden="true">
      <div className={styles.image} />
      <div className={styles.content}>
        <div className={styles.title} />
        <div className={styles.titleShort} />
        <div className={styles.location} />
        <div className={styles.divider} />
        <div className={styles.footer}>
          <div className={styles.footerChip} />
          <div className={styles.footerChip} />
        </div>
        <div className={styles.priceLabel} />
        <div className={styles.priceValue} />
      </div>
    </div>
  );
};

export default SkeletonCard;
